import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInterceptor";
import { toast } from "react-toastify";
import { ImageLink } from "../constants";

const AddProjectImages = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [tabData, setTabData] = useState([]);
  const [projectData, setProjectData] = useState([]);

  const [data, setData] = useState({
    projectId: editData?.projectId?._id || "",
    galleryTabId: editData?.galleryTabId?._id || "",
    position: editData?.position || "",
    desktopImg: editData?.desktopImg || "",
  });

  const [errors, setErrors] = useState({
    projectId: "",
    galleryTabId: "",
    position: "",
    desktopImg: "",
  });

  const handleChange = (e) => {
    const { name, files, value } = e.target;
    if (name === "desktopImg") {
      setData({ ...data, [name]: files.length > 0 ? files[0] : null });
    } else {
      setData({ ...data, [name]: value });
    }
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let hasErrors = false;

    // Validate email
    if (!data.projectId.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        projectId: "Project is required",
      }));
      hasErrors = true;
    }
    if (!data.galleryTabId.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        galleryTabId: "Gallery Tab is required",
      }));
      hasErrors = true;
    }
    if (!data.position.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        position: "Position is required",
      }));
      hasErrors = true;
    }
    if (!data.desktopImg) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        desktopImg: "img is required",
      }));
      hasErrors = true;
    }
    if (hasErrors) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append("projectId", data.projectId);
      formData.append("galleryTabId", data.galleryTabId);
      formData.append("position", data.position);
      if (data.desktopImg instanceof File) {
        formData.append("desktopImg", data.desktopImg);
      }

      const response = await axiosInstance.post(
        `project/createProjectImage`,
        formData
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/project-gallery");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("projectId", data.projectId);
      formData.append("galleryTabId", data.galleryTabId);
      formData.append("position", data.position);
      if (data.desktopImg instanceof File) {
        formData.append("desktopImg", data.desktopImg);
      }

      const response = await axiosInstance.put(
        `project/updateProjectImage/${editData?._id}`,
        formData
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/project-gallery");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(
        `project/getWithoutPaginationProject`
      );
      const { data } = response.data;
      setProjectData(data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };

  const fetchDataTab = async () => {
    try {
      const response = await axiosInstance.get(
        `galleryTab/getWithoutPaginationTab`
      );
      const { data } = response.data;
      setTabData(data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };

  useEffect(() => {
    fetchData();
    fetchDataTab();
  }, []);

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
          <h3 className="page-title">Add Project Image</h3>
        </div>
        <div className="row grid-margin stretch-card">
          <div className="col-md-8  ">
            <div className="card">
              <div className="card-body">
                <form
                  className="pt-3"
                  onSubmit={editData?._id ? handleUpdate : handleSubmit}
                >
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername1"
                      className="col-sm-3 col-form-label"
                    >
                      Project
                    </label>
                    <div className="col-sm-9">
                      <select
                        className="form-control form-control-lg"
                        id="exampleFormControlSelect1"
                        name="projectId"
                        value={data.projectId}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          -- Please Select Project --
                        </option>
                        {projectData.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                      {errors.projectId && (
                        <p className="text-danger">{errors.projectId}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername1"
                      className="col-sm-3 col-form-label"
                    >
                      Gallery Type
                    </label>
                    <div className="col-sm-9">
                      <select
                        className="form-control form-control-lg"
                        id="galleryTabId"
                        name="galleryTabId"
                        value={data.galleryTabId}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          -- Please Select Tab --
                        </option>
                        {tabData.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                      {errors.galleryTabId && (
                        <p className="text-danger">{errors.galleryTabId}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Position
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        id="position"
                        name="position"
                        placeholder="Enter position"
                        value={data.position}
                        onChange={handleChange}
                      />
                      {errors.position && (
                        <p className="text-danger">{errors.position}</p>
                      )}
                    </div>
                  </div>
                  {/* <div className="form-group row">
                    <label
                      for="exampleInputUsername1"
                      className="col-sm-3 col-form-label"
                    >
                      Asset Type
                    </label>
                    <div className="col-sm-9">
                      <select
                        className="form-control form-control-lg"
                        id="assetType "
                        name="assetType "
                        value={data.assetType}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          -- Please Select Tab --
                        </option>
                        <option value="image">
                          Image
                        </option>
                        <option value="video">
                          Video
                        </option>
                      </select>
                      {errors.galleryTabId && (
                        <p className="text-danger">{errors.galleryTabId}</p>
                      )}
                    </div>
                  </div> */}

                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Images
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="file"
                        className="form-control form-control-sm"
                        id="desktopImg"
                        name="desktopImg"
                        placeholder="Enter project img"
                        // value={data.desktopImg}
                        onChange={handleChange}
                      />
                      {errors.desktopImg && (
                        <p className="text-danger">{errors.desktopImg}</p>
                      )}
                    </div>
                  </div>

                  <div className="text-center mt-4">
                    <Link to="/project-gallery">
                      <button className="btn btn-secondary mr-2">Back </button>
                    </Link>
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-4 stretch-card">
            <div className="card">
              {data.desktopImg && (
                <div className="w-100 h-80 text-center mb-4">
                  <p className="mt-3">Image Preview</p>
                  <br />
                  {data.desktopImg instanceof File ? (
                    <img
                      src={URL.createObjectURL(data.desktopImg)}
                      alt="Preview"
                      className="w-75"
                    />
                  ) : (
                    <img
                      src={ImageLink(data.desktopImg)}
                      alt="Preview"
                      className="w-75"
                    />
                  )}
                </div>
              )}
              {/* {data.desktopImg && ( */}
              {/* {data.desktopImg && typeof data.desktopImg === 'string' && data.desktopImg.match(/\.(jpeg|jpg|png)$/) ? (
                <div className="border w-100 h-75 text-center">
                  <h6 className="mt-3">Preview</h6>
                  <br />
                  <img src={ImageLink(data.desktopImg)} alt="desktop_image_preview" className="w-75" />
                </div>
              ) : data.desktopImg && typeof data.desktopImg === 'string' && data.desktopImg.match(/\.(mp4|mov|avi)$/) ? (
                <div className="w-100 h-80 text-center mb-4">
                  <video className="w-100 mb-3 p-2" width="320" height="240" controls>
                    <source src={ImageLink(data.desktopImg)} type="video/mp4" />
                  </video>
                </div>
              ) : data.desktopImg instanceof File && data.desktopImg.type.startsWith('image/') ? (
                <div className="border w-100 h-75 text-center">
                  <h6 className="mt-3">Preview</h6>
                  <br />
                  <img src={URL.createObjectURL(data.desktopImg)} alt="desktop_image_preview" className="w-75" />
                </div>
              ) : data.desktopImg instanceof File ? (
                <video className="w-100 mb-3 p-2" width="320" height="240" controls>
                  <source src={URL.createObjectURL(data.desktopImg)} type="video/mp4" />
                </video>
              ) : (
                <div className="text-center mt-4">No file uploaded</div>
              )} */}
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProjectImages;
